<template>
  <div v-if="variant === 'hero'" class="prospect-interest-hero">
    <div class="prospect-interest-hero-icon" aria-hidden="true">
      <i class="fa-solid fa-user-plus"></i>
    </div>
    <h2 class="prospect-interest-hero-title">Start collecting leads</h2>
    <p class="prospect-interest-hero-subtitle">
      Share your interest form on your team website, social media, or in a text or email.
      When someone calls or texts you directly, use the button below to fill it out on their behalf.
    </p>

    <div class="prospect-interest-hero-url">
      <a :href="inquiryUrl" target="_blank" rel="noopener" :title="inquiryUrl">
        {{ inquiryUrl }}
      </a>
      <copy-icon :text="inquiryUrl"></copy-icon>
    </div>

    <div class="flex justify-center m-t-md">
      <a
        :href="inquiryUrl"
        target="_blank"
        rel="noopener"
        class="btn btn-primary"
      >
        <i class="fa-solid fa-plus m-r-xxs"></i> Add lead
      </a>
    </div>
  </div>

  <div v-else class="prospect-interest-card">
    <div class="flex justify-space-between align-items-baseline m-b-xxs">
      <span class="prospect-stat-label">Interest form</span>
      <a
        :href="inquiryUrl"
        target="_blank"
        rel="noopener"
        class="btn btn-primary btn-sm"
        title="Opens the public form in a new tab so you can fill it out for a lead"
      >
        <i class="fa-solid fa-plus m-r-xxs"></i> Add lead
      </a>
    </div>
    <div class="flex align-items-center gap-x-xs">
      <a
        :href="inquiryUrl"
        target="_blank"
        rel="noopener"
        class="text-14 prospect-interest-url"
        :title="inquiryUrl"
      >
        {{ inquiryUrl }}
      </a>
      <copy-icon :text="inquiryUrl"></copy-icon>
    </div>
  </div>
</template>

<script>
import CopyIcon from './copy_icon.vue';

export default {
  name: 'prospect-interest-form-card',
  components: { CopyIcon },
  props: {
    inquiryUrl: { type: String, required: true },
    // 'compact' sits beside the stats strip once the team has leads;
    // 'hero' is the full-width teaching empty state for brand-new teams.
    variant: {
      type: String,
      default: 'compact',
      validator: (v) => ['compact', 'hero'].includes(v),
    },
  },
};
</script>
